import { Link, useParams } from "react-router-dom";
import { LEGAL, LEGAL_NAME, GSTIN } from "@/data/legal";

export default function Legal() {
  const { slug } = useParams();
  const doc = LEGAL[slug] || LEGAL.terms;
  return (
    <div data-testid={`legal-page-${slug}`}>
      <section className="border-b relative grain">
        <div className="container-x py-16 md:py-20">
          <div className="eyebrow mb-4">Legal</div>
          <h1 className="text-4xl sm:text-5xl font-extrabold tracking-tight">{doc.title}</h1>
        </div>
      </section>
      <section className="py-14">
        <div className="container-x grid lg:grid-cols-12 gap-10">
          <aside className="lg:col-span-3">
            <nav className="lg:sticky lg:top-24 space-y-1">
              {Object.entries(LEGAL).map(([k, v]) => (
                <Link key={k} to={`/legal/${k}`} data-testid={`legal-nav-${k}`} className={`block rounded-lg px-3 py-2 text-sm ${k === slug ? "bg-[#7c3aed]/10 text-[#7c3aed] font-semibold" : "text-muted-foreground hover:text-foreground"}`}>{v.title}</Link>
              ))}
            </nav>
          </aside>
          <article className="lg:col-span-9 max-w-3xl prose-legal">
            <p className="!text-foreground !text-base">{doc.intro}</p>
            <p className="mt-3 text-xs" data-testid="legal-entity">{LEGAL_NAME} · GSTIN {GSTIN} · Legal & privacy: legal@sliance.com · Support: support@sliance.com</p>
            {doc.sections.map(([h, items]) => (
              <div key={h}>
                <h2>{h}</h2>
                <ul>{items.map((t) => <li key={t}>{t}</li>)}</ul>
              </div>
            ))}
          </article>
        </div>
      </section>
    </div>
  );
}
